<!-- Spinner -->
@if (!loginDisplay) {
  <div class="spinner-overlay">
    <mat-progress-spinner
      mode="indeterminate"
      [diameter]="30"
      class="spinner"
    ></mat-progress-spinner>
  </div>
}

@if (loginDisplay) {
  <div>
    <div class="container">
      <div class="header">
        <app-header [showHeaderElements]="!isLoginPage"></app-header>
      </div>
    </div>
    @if (!isLoginPage) {
      <mat-drawer-container class="sidenav-container" autosize>
        <mat-drawer
          style="visibility: visible !important"
          class="side-nav"
          mode="side"
          [opened]="true"
          >
          <app-sidenav-list
            (toggleMenu)="toggleMenu()"
            [isExpanded]="isExpanded"
            ></app-sidenav-list
          ></mat-drawer>
          <mat-drawer-content class="sidenav-content"
            ><router-outlet></router-outlet
          ></mat-drawer-content>
        </mat-drawer-container>
      }
      @if (isLoginPage) {
        <router-outlet></router-outlet>
      }
    </div>
  }
